export const PBB_LOGO = 'https://customer-assets-wrfwihn1.emergentagent.net/wingman/e3dd0bb5-cd52-4986-8bcb-0b93e872dd3d/attachments/a3c52e10cea441228c71b76a0bf010e8_pbb640.png';
